import React, { useState, useEffect, useContext, createContext } from "react";
import * as authService from "../services/authService";

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = authService.onAuthChange(setCurrentUser, setIsLoading);
    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    return await authService.login(email, password);
  };
  const signUp = async (store) => {
    const response = await authService.signUp(store);
    return response;
  };

  const logOut = () => authService.logOut();
  return (
    <AuthContext.Provider value={{ currentUser, login, signUp, logOut }}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};

const useAuthContext = () => useContext(AuthContext);

export { AuthProvider, useAuthContext };
